const $ea1a02edf608271f$var$chances = [
    [
        0,
        1,
        2
    ],
    [
        3,
        4,
        5
    ],
    [
        6,
        7,
        8
    ],
    [
        0,
        3,
        6
    ],
    [
        1,
        4,
        7
    ],
    [
        2,
        5,
        8
    ],
    [
        0,
        4,
        8
    ]
];
var $ea1a02edf608271f$export$2e2bcd8739ae039 = $ea1a02edf608271f$var$chances;


const $650607d6ef817a02$var$headingEl = document.querySelector(".heading");
const $650607d6ef817a02$var$currPlayerEl = document.querySelector(".current-player");
const $650607d6ef817a02$var$boxes = document.querySelectorAll(".box");
const $650607d6ef817a02$var$resetBtn = document.querySelector(".btn-reset");
// ======Game Variable=====
const $650607d6ef817a02$var$players = [
    "O",
    "X"
];
let $650607d6ef817a02$var$currPlayer;
let $650607d6ef817a02$var$virtualgrid;
function $650607d6ef817a02$var$getPlayer() {
    const rn = Math.floor(Math.random() * 2);
    return $650607d6ef817a02$var$players[rn];
}
function $650607d6ef817a02$var$swapPlayer() {
    const newPlayer = $650607d6ef817a02$var$currPlayer === "O" ? "X" : "O";
    $650607d6ef817a02$var$currPlayer = newPlayer;
    $650607d6ef817a02$var$currPlayerEl.textContent = $650607d6ef817a02$var$currPlayer;
}
// ===start game====
function $650607d6ef817a02$var$startGame() {
    $650607d6ef817a02$var$currPlayer = $650607d6ef817a02$var$getPlayer();
    $650607d6ef817a02$var$virtualgrid = new Array(9).fill("");
    $650607d6ef817a02$var$currPlayer.textContent = $650607d6ef817a02$var$currPlayer;
}
function $650607d6ef817a02$var$checkIfwon() {
    (0, $ea1a02edf608271f$export$2e2bcd8739ae039).forEach((chances)=>{
        const [c1, c2, c3] = chances;
        if ($650607d6ef817a02$var$virtualgrid[c1] === $650607d6ef817a02$var$virtualgrid[c2] && $650607d6ef817a02$var$virtualgrid[c2] === $650607d6ef817a02$var$virtualgrid[c1] && $650607d6ef817a02$var$virtualgrid[c3] === $650607d6ef817a02$var$virtualgrid[c2] && $650607d6ef817a02$var$virtualgrid[c1] !== "" && $650607d6ef817a02$var$virtualgrid[c2] !== "" && $650607d6ef817a02$var$virtualgrid[c3] !== "") {
            const winner = $650607d6ef817a02$var$virtualgrid[c1];
            $650607d6ef817a02$var$headingEl.textContent = `winner:${winner}`;
            $650607d6ef817a02$var$boxes[c1].classList.add("green");
            $650607d6ef817a02$var$boxes[c2].classList.add("green");
            $650607d6ef817a02$var$boxes[c3].classList.add("green");
            $650607d6ef817a02$var$boxes.forEach((box)=>box.style.pointerEvents = "none");
            $650607d6ef817a02$var$resetBtn.classList.toggle("active");
            return;
        }
    });
    const x = $650607d6ef817a02$var$virtualgrid.every((e)=>e !== "");
    if (x) $650607d6ef817a02$var$headingEl.textContent = "there is tie!";
    $650607d6ef817a02$var$resetBtn.classList.toggle("active");
}
function $650607d6ef817a02$var$handleBoxClick(input) {
    if ($650607d6ef817a02$var$virtualgrid[input] === "") {
        console.log("input");
        $650607d6ef817a02$var$boxes[input].textContent = $650607d6ef817a02$var$currPlayer;
        $650607d6ef817a02$var$boxes[input].style.cursor = "auto";
        $650607d6ef817a02$var$virtualgrid[input] = $650607d6ef817a02$var$currPlayer;
        // console.log(virtualgrid);
        $650607d6ef817a02$var$checkIfwon();
        $650607d6ef817a02$var$swapPlayer();
    }
}
$650607d6ef817a02$var$boxes.forEach(function(_, index) {
    _.addEventListener("click", function() {
        $650607d6ef817a02$var$handleBoxClick(index);
    });
});
function $650607d6ef817a02$var$handleReset() {
// alert("Bhai ruk jaa abhi game pura nhi hua hai");
}
$650607d6ef817a02$var$resetBtn.addEventListener("click", $650607d6ef817a02$var$handleReset);
document.addEventListener("DOMContentLoaded", $650607d6ef817a02$var$startGame);


//# sourceMappingURL=index.f1f1f9aa.js.map
